import Cookies from 'js-cookie'
import store from '../index'

import { deepClone } from '@/utils'
import { removeToken, setToken } from '@/utils/cookie'
import { clearStore, getStore, setStore } from '@/utils/store'

import { getUserInfo, logout, refreshToken, getAccessTokenForWXLogin, getAccessTokenForWXRegister } from '@/api/login'
import { dragCaptchaLogin } from '@/api/system/auth/dragCaptcha'
import { check } from '@/api/system/auth/jigsawCaptcha'
import { handleRouteByUserRole, formatRoutes } from '@/utils/router/other'
import allRoutes from '@/views/corporation/routes'
import router from '@/router'

const login = {
  state: {
    access_token: getStore({ name: 'access_token' }) || '',
    refresh_token: getStore({ name: 'refresh_token' }) || '',
    userInfo: getStore({name: 'userInfo'}) || {},
    roles: Cookies.get('roles') || [],
    routes: getStore({name: 'routes'}) || [],
    menus: getStore({name: 'menus'}) || [],
    menusLang_zh: getStore({name: 'menus-lang_zh'}) || null,
    menusLang_en: getStore({name: 'menus-lang_en'}) || null,
    memberInfo: getStore({name: 'memberInfo'}) || null,
    memberRoutes: getStore({name: 'memberRoutes'}) || [],
    memberMenus: getStore({name: 'memberMenus'}) || [],
    loginActive: getStore({name: 'loginActive'}) || 1,
    loginData: getStore({name: 'loginData'}) || null,
    loginType: Cookies.get('loginType') || 'cu', // 登录类型: member服务商会员(团队队长)登录 cu(企业用户)
    teamMemberInfo: getStore({name: 'teamMemberInfo'}) || null, // 团队会员信息
    appInfo: getStore({name: 'appInfo'}) || null // 应用信息
  },
  actions: {
    /**
     * 添加登录后路由
     */
    addRoutes({ commit, state, dispatch }) {
      const routes = handleRouteByUserRole(allRoutes, store.state.corporation.userInfo)
      commit('SET_ROUTES', routes)
      router.addRoutes(formatRoutes(routes))
    },
    /**
     * 企业认证后用户角色角色会添加“已认证用户”, 更新缓存中的路由, 然后刷新页面重新构建
     */
    refreshRoutes({ commit, state, dispatch }) {
      const routes = handleRouteByUserRole(allRoutes, store.state.corporation.userInfo)
      commit('SET_ROUTES', routes)
      window.location.reload()
    },
    /**
     * 获取用户信息
     */
    GetUserInfo({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((response) => {
            const data = response.data.data
            commit('SET_ROLES', 'admin')
            commit('SET_USER_INFO', data)
            commit('SET_THEME_COLOR', data.themeColorHex || '#1E1A1A')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * 登录(滑动验证码)
     */
    dragCaptchaLogin({ commit, state, dispatch }, loginData) {
      return new Promise((resolve, reject) => {
        dragCaptchaLogin(loginData)
          .then((response) => {
            let data = response.data.data
            commit('initIndex')
            commit('SET_ACCESS_TOKEN', data.access_token)
            commit('SET_REFRESH_TOKEN', data.refresh_token)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * 登录(拼图验证码)
     */
    jigsawCaptchaLogin({ commit, state, dispatch }, form) {
      return new Promise((resolve, reject) => {
        check(form)
          .then((response) => {
            let respData = response.data
            if (respData.code === 0) {
              let data = respData.data
              // commit('initIndex')
              commit('SET_ACCESS_TOKEN', data.access_token)
              commit('SET_REFRESH_TOKEN', data.refresh_token)
            }
            resolve(respData)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * 微信扫码登录 by meijiangshun
     */
    LoginByWX({ commit, state, dispatch }, oauth2Sessionid) {
      return new Promise((resolve, reject) => {
        getAccessTokenForWXLogin({ oauth2Sessionid })
          .then((response) => {
            let respData = response.data
            if (respData.code === 0) {
              let data = respData.data
              commit('initIndex')
              commit('SET_ACCESS_TOKEN', data.access_token)
              commit('SET_REFRESH_TOKEN', data.refresh_token)
              resolve()
            } else {
              reject(respData.msg)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * 微信扫码注册
     */
    RegisterByWX({ commit, state, dispatch }, oauth2Sessionid) {
      return new Promise((resolve, reject) => {
        getAccessTokenForWXRegister({ oauth2Sessionid })
          .then((response) => {
            let respData = response.data
            if (respData.code === 0) {
              let data = respData.data
              commit('initIndex')
              commit('SET_ACCESS_TOKEN', data.access_token)
              commit('SET_REFRESH_TOKEN', data.refresh_token)
              resolve()
            } else {
              reject(respData.msg)
            }
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * 登出
     */
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout()
          .then(() => {
            // 清除用户信息
            // commit('SET_USER_INFO', {})
            // commit('SET_ACCESS_TOKEN', '')
            // commit('SET_REFRESH_TOKEN', '')
            commit('SET_ROLES', '')
            clearState()
            clearStore()
            removeToken()
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    /**
     * 清除缓存
     */
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        // 清除用户信息
        // commit('SET_USER_INFO', {})
        // commit('SET_ACCESS_TOKEN', '')
        // commit('SET_REFRESH_TOKEN', '')
        commit('SET_ROLES', '')
        clearState()
        clearStore()
        removeToken()
        resolve()
      })
    }
  },
  mutations: {
    /**
     * 刷新token
     */
    REFRESH_TOKEN: (state, token) => {
      refreshToken({ refresh_token: Cookies.get('refresh_token') }).then((response) => {
        let data = response.data
        if (data && data.code === 0) {
          // 保存token到store和cookie
          store.commit('SET_ACCESS_TOKEN', data.data.access_token)
          // 保存refresh_token
          store.commit('SET_REFRESH_TOKEN', data.data.refresh_token)
        }
      })
    },

    /**
     * 保存路由
     */
    SET_ROUTES: (state, routes) => {
      state.routes = routes
      setStore({
        name: 'routes',
        content: state.routes
      })
    },

    SET_MENUS_LANG_ZH: (state, menusLangZh) => {
      state.menusLang_zh = menusLangZh
      setStore({
        name: 'menus-lang_zh',
        content: state.menusLang_zh
      })
    },

    SET_MENUS_LANG_EN: (state, menusLangEn) => {
      state.menusLang_en = menusLangEn
      setStore({
        name: 'menus-lang_en',
        content: state.menusLang_en
      })
    },

    /**
     * 保存左侧菜单
     */
    SET_MENUS: (state, menus) => {
      state.menus = menus
      setStore({
        name: 'menus',
        content: state.menus
        // ,
        // type: 'session'
      })
    },

    /**
     * 设置access_token
     */
    SET_ACCESS_TOKEN: (state, accessToken) => {
      state.access_token = accessToken
      setToken(accessToken)
      setStore({
        name: 'access_token',
        content: state.access_token
      })
    },

    /**
     * 设置refresh_token
     */
    SET_REFRESH_TOKEN: (state, rfToken) => {
      state.refresh_token = rfToken
      Cookies.set('refresh_token', rfToken)
      setStore({
        name: 'refresh_token',
        content: state.refresh_token
      })
    },

    /**
     * 设置用户角色
     */
    SET_ROLES: (state, roles) => {
      state.roles = roles
      Cookies.set('roles', roles)
    },

    /**
     * 设置用户信息
     */
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
      setStore({
        name: 'userInfo',
        content: state.userInfo
        // ,
        // type: 'session'
      })
    },
    /**
     * 设置团队用户信息
     */
    SET_TEAM_MEMBER_INFO: (state, teamMemberInfo) => {
      state.teamMemberInfo = teamMemberInfo
      setStore({
        name: 'teamMemberInfo',
        content: state.teamMemberInfo
      })
    },
    SET_APP_INFO: (state, appInfo) => {
      state.appInfo = appInfo
      setStore({
        name: 'appInfo',
        content: appInfo
      })
    },
    /**
     * 设置会员信息
     */
    SET_MEMBER_INFO: (state, memberInfo) => {
      state.memberInfo = memberInfo
      setStore({
        name: 'memberInfo',
        content: state.memberInfo
      })
    },

    /**
     * 保存会员路由
     */
    SET_MEMBER_ROUTERS: (state, memberRoutes) => {
      state.memberRoutes = memberRoutes
      setStore({
        name: 'memberRoutes',
        content: state.memberRoutes
      })
    },

    /**
     * 保存会员菜单
     */
    SET_MEMBER_MENUS: (state, memberMenus) => {
      state.memberMenus = memberMenus
      setStore({
        name: 'memberMenus',
        content: state.memberMenus
      })
    },
    /**
     * 设置注册进度
     */
    SET_LOGIN_ACTIVE: (state, loginActive) => {
      state.loginActive = loginActive
      setStore({
        name: 'loginActive',
        content: state.loginActive
      })
    },
    /**
     * 设置登录数据
     * @param state
     * @param loginData
     * @constructor
     */
    SET_LOGIN_DATA: (state, loginData) => {
      state.loginData = loginData
      setStore({
        name: 'loginData',
        content: state.loginData
      })
    },
    /**
     * 设置登录类型
     * @param state
     * @param loginType
     * @constructor
     */
    SET_LOGIN_TYPE: (state, loginType) => {
      state.loginType = loginType
      Cookies.set('loginType', loginType)
    }
  }
}

export default login

/**
 * 重置store里所有数据
 */
export const clearState = function() {
  let initState = deepClone(window.initState)
  store.state.app = initState.app
  store.state.login = initState.login
  store.state.corporation = initState.corporation
  store.state.headBar = initState.headBar
}



// WEBPACK FOOTER //
// ./src/store/modules/login.js